import PropTypes from 'prop-types';
import { useState } from 'preact/hooks';
import { getAssetImageUrl } from '@util/common.js';
import ArrowRightButton from '@components/buttons/arrow-right.button.jsx';
import { NavLink } from 'react-router-dom';
import CardBadge from '@components/shared/cards/components/card-badge.jsx';

export default function ItemCard({
  thumbnail,
  name,
  description,
  link,
  isFirst = false,
  isLast = false,
  className = '',
  badges,
}) {
  if (isFirst) className = `${className} 2xl:col-span-2 md:col-span-1`;

  if (isLast) className = `${className} lg:col-span-1 2xl:col-span-2`;

  const [cardHover, setCardHover] = useState(false);

  const hoverHandler = () => {
    setCardHover(!cardHover);
  };

  if (!badges)
    badges = {
      isUpdated: false,
      isFeatured: false,
      isNew: false,
    };

  return (
    <div className={className}>
      <NavLink className="h-full" unstable_viewTransition to={link}>
        <div
          className="card category-card bg-neutral-50 hover:bg-neutral-100 transition-colors shadow-lg hover:shadow-xl relative h-full"
          onMouseOver={hoverHandler}
          onMouseOut={hoverHandler}
        >
          <div className="flex flex-row justify-between px-0 pt-0 pb-0 h-20 border-t border-l border-r border-neutral-200 rounded-t-md">
            <div className="basis-1/2 px-4 py-3">
              <img
                className="h-full w-auto object-contain"
                src={getAssetImageUrl(thumbnail)}
                alt="Thumbnail"
              />
            </div>
            <div className="basis-1/4">
              <CardBadge badges={badges} />
            </div>
          </div>
          <div className="card-body bg-white rounded-b-md border border-neutral-200">
            <h2 className="card-title text-2xl font-extrabold">{name}</h2>
            <p className="prose mb-2 mt-4">{description}</p>
            <div className="card-actions flex items-center">
              <span className="flex-grow"></span>
              <ArrowRightButton hover={cardHover} link={link} />
            </div>
          </div>
        </div>
      </NavLink>
    </div>
  );
}

ItemCard.propTypes = {
  thumbnail: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
  type: PropTypes.string,
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool,
  className: PropTypes.string,
  badges: PropTypes.shape({
    isNew: PropTypes.bool,
    isUpdated: PropTypes.bool,
    isFeatured: PropTypes.bool,
  }),
};
